import React from 'react';
import { makeStyles } from '@mui/styles';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  tableHeaderCell: {
    fontFamily: 'DaimlerCS-Demi',
    fontSize: 14,
    borderRadius: 0,
  },
  tableHeaderRow: {
    cursor: 'pointer',
  },
}));

type AffectedHeaderRowProps = {
  checked: boolean;
  onCheckAll: (checked: boolean) => void; // eslint-disable-line no-unused-vars
  isEditable: boolean;
  isSeries: boolean;
};

const AffectedHeaderRow: React.FC<AffectedHeaderRowProps> = (props) => {
  const { checked, onCheckAll = () => {}, isEditable, isSeries } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableRow className={classes.tableHeaderRow}>
      {isEditable && (
        <TableCell padding="checkbox">
          <Checkbox
            checked={checked}
            color="primary"
            onClick={() => onCheckAll(!checked)}
          />
        </TableCell>
      )}
      <TableCell className={classes.tableHeaderCell} />
      <TableCell className={classes.tableHeaderCell}>{t(`affectedVehicles.${isSeries ? 'modelSeries' : 'affectedPlant'}`)}</TableCell>
      <TableCell className={classes.tableHeaderCell} width="50%">{t(`affectedVehicles.${isSeries ? 'typeVersion' : 'producedModelSeries'}`)}</TableCell>
      <TableCell className={classes.tableHeaderCell}>{t(`affectedVehicles.${isSeries ? 'plants' : 'producedTypeVersion'}`)}</TableCell>
    </TableRow>
  );
};

export default AffectedHeaderRow;
